import { DateRange } from 'src/types/Search';

export enum FilterName {
  sortBy = 'sortBy',
  dateRange = 'dateRange',
  startDate = 'startDate',
  endDate = 'endDate',
  quickFilters = 'quickFilters',
  replies = 'replies',
  categories = 'categories',
  tags = 'tags',
  groups = 'groups',
  searchTerm = 'searchTerm',
}

export enum SortByType {
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
  totalViews = 'totalViews',
  totalReplies = 'totalReplies',
  totalVotes = 'totalVotes',
  relevance = 'relevance',
  lastActivityTime = 'lastActivityTime',
}

export enum DateRangeType {
  allTime = 'allTime',
  pastDay = 'pastDay',
  pastWeek = 'pastWeek',
  pastMonth = 'pastMonth',
  threeMonths = 'threeMonths',
  pastYear = 'pastYear',
  custom = 'custom',
}

export interface SelectedFiltersStateType {
  [FilterName.sortBy]: SortByType;
  [FilterName.dateRange]: DateRangeType;
  [FilterName.startDate]?: DateRange['startDate'];
  [FilterName.endDate]?: DateRange['endDate'];
  [FilterName.quickFilters]: Array<string>;
  [FilterName.replies]: string;
  [FilterName.categories]: Array<string>;
  [FilterName.tags]: Array<string>;
  [FilterName.groups]: Array<string>;
  [FilterName.searchTerm]: string;
}

export enum FilterLabels {
  hasReplies = 'hasReplies',
  hasNoReplies = 'hasNoReplies',
  repliesAll = 'repliesAll',
  hasSolution = 'hasSolution',
  hasAmazonReply = 'hasAmazonReply',
  userId = 'userId',
}

export type RepliesFilter = FilterLabels.repliesAll
| FilterLabels.hasReplies
| FilterLabels.hasNoReplies;

enum PinnedThreadTypes {
  listing = 'listing',
  categories = 'categories',
  groups = 'groups',
}

export interface SearchFilters {
  sortBy?: SortByType
  pinnedToCriteria?: Array<PinnedThreadTypes>
}
